var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,0 479.784,0 256,223.784 32.216,0 0,0 0,32.216 223.784,256 0,479.784 0,512 32.216,512   256,288.216 479.784,512 512,512 512,479.784 288.216,256 512,32.216 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M282.556,54.768c0,0-2.795-4.193-6.989-1.398c0,0,4.848,3.494,1.572,7.163  c-3.467,3.883-8.233,0.085-8.532-2.698c1.272-0.097,2.277-1.148,2.277-2.444c0-1.36-1.103-2.463-2.463-2.463  c-1.36,0-2.463,1.103-2.463,2.463c0,1.062,0.676,1.959,1.618,2.305c-0.601,2.382-6.849,4.205-8.65,0.26  c-2.028-4.442,1.179-8.211,5.503-7.687c0,0-0.83-5.503-6.683-3.189c0,0,2.446-6.29-1.747-10.483  c-4.193,4.193-1.747,10.483-1.747,10.483c-5.853-2.315-6.683,3.189-6.683,3.189c4.324-0.524,7.531,3.245,5.503,7.687  c-1.801,3.945-8.049,2.122-8.65-0.26c0.942-0.346,1.618-1.243,1.618-2.305c0-1.36-1.103-2.463-2.463-2.463s-2.463,1.103-2.463,2.463  c0,1.297,1.005,2.347,2.277,2.444c-0.299,2.783-5.065,6.58-8.532,2.698c-3.276-3.669,1.572-7.163,1.572-7.163  c-4.193-2.795-6.989,1.398-6.989,1.398c-1.398-5.591-6.989-4.193-6.989-4.193c5.591,6.989,9.702,21.404,9.702,21.404h47.686  c0,0,4.111-14.415,9.702-21.404C289.545,50.575,283.954,49.177,282.556,54.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M279.843,71.979c-7.714-2.719-15.779-4.078-23.843-4.078s-16.129,1.359-23.843,4.078  C219.65,126.779,256,141.426,256,141.426S292.35,126.778,279.843,71.979z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M238.561,91.476c0,0-1.146-0.216-2.142,0.581c0,0-0.349-1.378,1.445-1.711   C239.657,90.014,238.561,91.476,238.561,91.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M237.181,89.732c0,0-0.908-0.732-2.163-0.5c0,0,0.344-1.38,2.082-0.825   C238.838,88.962,237.181,89.732,237.181,89.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M237.932,90.446c0,0-1.252-0.216-2.342,0.581c0,0-0.381-1.378,1.579-1.711   C239.13,88.984,237.932,90.446,237.932,90.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M259.623,94.108c0,0-1.165,0.055-1.95,1.061c0,0-0.658-1.26,1.01-1.999   S259.623,94.108,259.623,94.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.915,92.606c0,0-1.053-0.502-2.22,0.014c0,0,0.016-1.422,1.834-1.284   C259.348,91.474,257.915,92.606,257.915,92.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.773,93.251c0,0-1.268,0.08-2.144,1.107c0,0-0.69-1.253,1.141-2.03   C259.6,91.552,258.773,93.251,258.773,93.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.931,94.826c0,0-0.436,0-1.217,0.735c0,0-0.56-1.25,1.087-1.863S272.931,94.826,272.931,94.826z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.095,93.11c0,0-0.983-0.544-2.136-0.116c0,0,0.097-1.366,1.839-1.128   C273.54,92.105,272.095,93.11,272.095,93.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M272.883,93.781c0,0-1.224,0.003-2.126,0.94c0,0-0.591-1.245,1.215-1.886   C273.778,92.195,272.883,93.781,272.883,93.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.644,82.827c0,0-1.053-0.7-2.387-0.328c0,0,0.238-1.52,2.171-1.091   C238.361,81.836,236.644,82.827,236.644,82.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.557,80.205c0,0-0.68-1.07-2.131-1.163c0,0,0.939-1.441,2.588-0.335   S236.557,80.205,236.557,80.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M236.563,81.598c0,0-1.11-0.82-2.577-0.517c0,0,0.329-1.603,2.408-1.011   C238.473,80.662,236.563,81.598,236.563,81.598z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M269.568,86.394c1.844,0.05,4.036-0.681,4.385-2.591c0.401-2.195-1.478-3.305-4.003-3.205  c-1.842,0.073-6.507,1.131-9.849,1.013c-3.305-0.116-3.395-3.387,1.611-3.039c7.424,0.515,8.603-0.448,8.603-0.448  c-3.986,0.747-5.58-0.648-9.815-0.648c-4.235,0-5.048,2.933-3.338,4.534c1.916,1.794,8.869,0.598,10.712,0.249  c1.844-0.349,4.183-0.367,4.368,0.93c0.166,1.163-2.923,1.1-5.111,1.016c-3.483-0.134-8.55,0.811-13.059,1.044  c-3.756,0.194-4.279-0.865-5.134-1.95c0.2-0.361,0.314-0.763,0.314-1.189c0-0.215-0.035-0.423-0.089-0.624  c0.284-0.312,0.582-0.809,0.719-1.618c0,0-0.961-0.169-1.687,0.198c-0.582-0.459-1.352-0.746-2.206-0.746  c-0.854,0-1.625,0.287-2.206,0.746c-0.726-0.366-1.687-0.198-1.687-0.198c0.137,0.809,0.435,1.306,0.718,1.618  c-0.054,0.201-0.089,0.409-0.089,0.624c0,0.782,0.377,1.489,0.983,1.996c0.293,0.244,0.509,0.567,0.584,0.942l0.105,0.531  c0.046,0.232,0.196,0.415,0.39,0.526c-3.096-0.319-4.561-2.265-5.314-3.347c-0.849-1.22-1.378-3.92-2.674-4.218l-0.764,4.069  c0,0,1.638,3.786,4.683,5.331c3.438,1.744,4.086,1.794,5.215,2.292c0.133,0.598-2.126,0.963-4.418,0.498  c-1.6-0.325-3.756-2.648-4.985-2.482l1.431,3.179c3.886,2.458,7.283,2.51,10.197,1.993c2.059-0.365,2.843-2.042,2.978-2.759  c0.841-0.156,1.756-0.33,4.595-1.027c1.189-0.292,2.557-0.446,3.92-0.51c0.384,0.876,1.263,1.999,4.285,2.104  c0,0,0.731,1.163-1.76,0.93c-2.491-0.232-3.131-1.009-4.592-0.843l1.304,3.102c0,0,3.189-1.096,7.108-0.698  c0,0,0.731,0.199,1.163-0.432s0.232-0.996-0.166-1.561c-0.224-0.318-0.354-1.349-0.424-2.191c1.435,0.361,5.841-0.533,7.433-0.4  c1.594,0.133,1.827,1.993,1.462,2.624c-0.365,0.631-3.704,0.091-3.704,0.091l1.121,3.064c0,0,0.336-0.162,1.187-0.963  c0.692-0.651,3.521-0.432,3.521-0.93v-5.676c0-0.269-0.234-0.479-0.502-0.455C270.845,87.434,269.568,86.394,269.568,86.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M244.679,84.376c0.093,0.183,0.164,0.382,0.201,0.593l0.094,0.531c0.033,0.186,0.18,0.321,0.35,0.321  h1.447c0.17,0,0.317-0.135,0.35-0.321l0.094-0.531c0.037-0.21,0.107-0.409,0.201-0.593H244.679z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M246.047,85.425c-0.334,0-0.594,0.04-0.559,0.506l0.135,1.985c0.023,0.304,0.206,0.535,0.424,0.535   s0.401-0.231,0.424-0.535l0.135-1.985C246.641,85.466,246.381,85.425,246.047,85.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M241.736,111.08c0,0-0.935-0.176-1.748,0.474c0,0-0.284-1.124,1.179-1.395   S241.736,111.08,241.736,111.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.611,109.658c0,0-0.741-0.597-1.764-0.408c0,0,0.281-1.125,1.698-0.673   C241.962,109.03,240.611,109.658,240.611,109.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M241.223,110.24c0,0-1.022-0.176-1.91,0.474c0,0-0.311-1.124,1.288-1.395   C242.2,109.048,241.223,110.24,241.223,110.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.916,113.227c0,0-0.95,0.045-1.59,0.866c0,0-0.537-1.028,0.824-1.63   C259.51,111.86,258.916,113.227,258.916,113.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.523,112.002c0,0-0.859-0.409-1.811,0.011c0,0,0.013-1.16,1.496-1.047   C258.692,111.078,257.523,112.002,257.523,112.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.223,112.529c0,0-1.035,0.065-1.748,0.903c0,0-0.563-1.022,0.93-1.656   C258.898,111.143,258.223,112.529,258.223,112.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.772,113.813c0,0-0.356,0-0.993,0.599c0,0-0.457-1.02,0.887-1.52   C271.009,112.393,269.772,113.813,269.772,113.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.09,112.414c0,0-0.802-0.444-1.742-0.094c0,0,0.079-1.115,1.5-0.92   C270.268,111.593,269.09,112.414,269.09,112.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M269.732,112.96c0,0-0.999,0.002-1.734,0.767c0,0-0.482-1.015,0.991-1.538   C270.462,111.667,269.732,112.96,269.732,112.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.172,104.026c0,0-0.859-0.571-1.947-0.268c0,0,0.194-1.24,1.771-0.89   C241.573,103.217,240.172,104.026,240.172,104.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.102,101.887c0,0-0.555-0.873-1.738-0.949c0,0,0.766-1.175,2.111-0.274   S240.102,101.887,240.102,101.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M240.106,103.023c0,0-0.906-0.669-2.102-0.422c0,0,0.269-1.307,1.964-0.824   S240.106,103.023,240.106,103.023z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M267.028,106.935c1.504,0.041,3.292-0.555,3.576-2.113c0.327-1.79-1.206-2.696-3.265-2.615  c-1.503,0.059-5.307,0.922-8.033,0.826c-2.696-0.095-2.769-2.762,1.314-2.479c6.056,0.42,7.017-0.366,7.017-0.366  c-3.251,0.61-4.552-0.528-8.006-0.528s-4.117,2.392-2.723,3.698c1.563,1.464,7.234,0.488,8.738,0.203  c1.504-0.284,3.412-0.3,3.563,0.759c0.135,0.948-2.384,0.897-4.169,0.829c-2.841-0.109-6.974,0.662-10.652,0.851  c-3.064,0.158-3.491-0.706-4.188-1.59c0.163-0.294,0.256-0.622,0.256-0.97c0-0.176-0.028-0.345-0.072-0.509  c0.231-0.254,0.474-0.66,0.586-1.32c0,0-0.784-0.137-1.376,0.161c-0.474-0.374-1.103-0.608-1.799-0.608s-1.325,0.234-1.799,0.608  c-0.592-0.299-1.376-0.161-1.376-0.161c0.112,0.66,0.355,1.066,0.586,1.32c-0.044,0.164-0.072,0.333-0.072,0.509  c0,0.638,0.307,1.215,0.802,1.628c0.239,0.199,0.416,0.463,0.476,0.768l0.086,0.433c0.038,0.19,0.16,0.338,0.318,0.429  c-2.525-0.26-3.721-1.848-4.334-2.73c-0.692-0.995-1.124-3.197-2.181-3.441l-0.623,3.319c0,0,1.336,3.088,3.82,4.349  c2.804,1.422,3.333,1.463,4.254,1.869c0.108,0.488-1.734,0.786-3.604,0.406c-1.305-0.265-3.064-2.16-4.066-2.024l1.167,2.593  c3.17,2.005,5.941,2.047,8.318,1.626c1.68-0.298,2.319-1.666,2.429-2.251c0.686-0.127,1.433-0.269,3.748-0.838  c0.97-0.238,2.086-0.364,3.197-0.416c0.313,0.715,1.03,1.63,3.495,1.716c0,0,0.596,0.948-1.436,0.759  c-2.032-0.19-2.554-0.823-3.746-0.687l1.063,2.53c0,0,2.601-0.894,5.798-0.569c0,0,0.596,0.163,0.948-0.352s0.19-0.813-0.135-1.273  c-0.183-0.259-0.288-1.1-0.346-1.787c1.171,0.294,4.764-0.434,6.063-0.326c1.301,0.108,1.49,1.626,1.192,2.14  c-0.298,0.515-3.021,0.075-3.021,0.075l0.914,2.499c0,0,0.274-0.132,0.969-0.786c0.564-0.531,2.872-0.352,2.872-0.759v-4.63  c0-0.22-0.191-0.391-0.409-0.371C268.07,107.784,267.028,106.935,267.028,106.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M246.726,105.289c0.076,0.15,0.133,0.312,0.164,0.483l0.077,0.433  c0.027,0.152,0.147,0.262,0.285,0.262h1.18c0.138,0,0.258-0.11,0.285-0.262l0.077-0.433c0.03-0.172,0.088-0.334,0.164-0.483H246.726  z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M247.842,106.145c-0.273,0-0.485,0.033-0.456,0.413l0.11,1.619c0.019,0.248,0.168,0.436,0.346,0.436   s0.327-0.188,0.346-0.436l0.11-1.619C248.327,106.178,248.115,106.145,247.842,106.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M245.267,126.662c0,0-0.7-0.132-1.308,0.355c0,0-0.213-0.842,0.882-1.045   C245.936,125.769,245.267,126.662,245.267,126.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.424,125.597c0,0-0.555-0.447-1.321-0.305c0,0,0.21-0.843,1.271-0.504   S244.424,125.597,244.424,125.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.883,126.033c0,0-0.765-0.132-1.43,0.355c0,0-0.233-0.842,0.965-1.045   C245.614,125.14,244.883,126.033,244.883,126.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M258.13,128.269c0,0-0.711,0.034-1.191,0.648c0,0-0.402-0.77,0.617-1.221   S258.13,128.269,258.13,128.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.087,127.352c0,0-0.643-0.307-1.356,0.008c0,0,0.009-0.868,1.12-0.784   C257.962,126.661,257.087,127.352,257.087,127.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M257.611,127.746c0,0-0.775,0.049-1.309,0.676c0,0-0.421-0.765,0.697-1.24   C258.116,126.709,257.611,127.746,257.611,127.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M266.258,128.708c0,0-0.266,0-0.743,0.449c0,0-0.342-0.764,0.664-1.138   C267.185,127.644,266.258,128.708,266.258,128.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M265.748,127.66c0,0-0.6-0.332-1.304-0.071c0,0,0.059-0.835,1.123-0.689   C266.63,127.046,265.748,127.66,265.748,127.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M266.229,128.07c0,0-0.748,0.002-1.298,0.574c0,0-0.361-0.76,0.742-1.152   S266.229,128.07,266.229,128.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.096,121.38c0,0-0.643-0.428-1.458-0.201c0,0,0.146-0.928,1.326-0.666   C245.144,120.775,244.096,121.38,244.096,121.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.043,119.778c0,0-0.415-0.653-1.301-0.711c0,0,0.573-0.88,1.581-0.205   C245.329,119.538,244.043,119.778,244.043,119.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M244.046,120.629c0,0-0.678-0.501-1.574-0.316c0,0,0.201-0.979,1.471-0.617   C245.213,120.057,244.046,120.629,244.046,120.629z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M264.204,123.558c1.126,0.03,2.465-0.416,2.678-1.582c0.245-1.34-0.903-2.019-2.445-1.958  c-1.125,0.044-3.974,0.691-6.015,0.619c-2.019-0.071-2.074-2.068,0.984-1.856c4.534,0.314,5.254-0.274,5.254-0.274  c-2.434,0.456-3.408-0.396-5.995-0.396s-3.083,1.791-2.039,2.769c1.17,1.096,5.417,0.365,6.542,0.152  c1.126-0.213,2.554-0.224,2.668,0.568c0.101,0.71-1.785,0.672-3.121,0.62c-2.127-0.082-5.222,0.495-7.975,0.637  c-2.294,0.118-2.614-0.528-3.136-1.191c0.122-0.22,0.192-0.466,0.192-0.726c0-0.132-0.021-0.258-0.054-0.381  c0.173-0.19,0.355-0.494,0.439-0.988c0,0-0.587-0.103-1.03,0.121c-0.355-0.28-0.826-0.455-1.347-0.455s-0.992,0.175-1.347,0.455  c-0.443-0.224-1.03-0.121-1.03-0.121c0.084,0.494,0.266,0.798,0.439,0.988c-0.033,0.123-0.054,0.25-0.054,0.381  c0,0.478,0.23,0.909,0.601,1.219c0.179,0.149,0.311,0.347,0.356,0.575l0.064,0.324c0.028,0.142,0.12,0.253,0.238,0.322  c-1.891-0.195-2.786-1.383-3.245-2.044c-0.518-0.745-0.842-2.394-1.633-2.576l-0.467,2.485c0,0,1,2.312,2.86,3.256  c2.1,1.065,2.495,1.095,3.185,1.4c0.081,0.365-1.298,0.588-2.698,0.304c-0.977-0.198-2.294-1.617-3.044-1.516l0.874,1.942  c2.374,1.501,4.448,1.533,6.228,1.217c1.258-0.223,1.736-1.247,1.819-1.685c0.513-0.095,1.073-0.202,2.807-0.627  c0.726-0.178,1.562-0.273,2.394-0.311c0.235,0.535,0.771,1.221,2.617,1.285c0,0,0.446,0.71-1.075,0.568  c-1.521-0.142-1.912-0.616-2.805-0.515l0.796,1.894c0,0,1.948-0.669,4.341-0.426c0,0,0.446,0.122,0.71-0.264  c0.264-0.385,0.142-0.609-0.101-0.953c-0.137-0.194-0.216-0.824-0.259-1.338c0.877,0.22,3.567-0.325,4.54-0.244  c0.974,0.081,1.116,1.217,0.893,1.603c-0.223,0.385-2.262,0.056-2.262,0.056l0.685,1.871c0,0,0.205-0.099,0.725-0.588  c0.422-0.398,2.15-0.264,2.15-0.568v-3.467c0-0.165-0.143-0.292-0.307-0.278C264.984,124.194,264.204,123.558,264.204,123.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M249.003,122.326c0.057,0.112,0.1,0.234,0.123,0.362l0.057,0.324c0.02,0.114,0.11,0.196,0.214,0.196  h0.884c0.104,0,0.193-0.082,0.213-0.196l0.057-0.324c0.023-0.128,0.066-0.25,0.123-0.362H249.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M249.839,122.967c-0.204,0-0.363,0.025-0.342,0.309l0.082,1.212c0.014,0.186,0.126,0.326,0.259,0.326  s0.245-0.141,0.259-0.326l0.082-1.212C250.202,122.991,250.043,122.967,249.839,122.967z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/je.4d39598b657714ef85999bf372b0f3bc.svg";
export { ForwardRef as ReactComponent };